import { ReactNode, Fragment, useCallback, useEffect } from 'react';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { PagesToolbarActions } from 'app/store/pagesToolbar/pagesToolbar.slice';
// Selectors
import { selectNewDesignEnabled, selectSelectedPageIds } from 'app/store/pagesToolbar/pagesToolbar.selectors';
// Mui
import { Box, Divider, Typography } from '@mui/material';
// Icons
import {
  Close as CloseIcon
} from '@mui/icons-material';
// Components
import { IconButton } from 'app/components/Mui';
// 
import * as Actions from './Actions';

type Props = {
  children: ReactNode;
  renderActions?: ReactNode;
}

const ActionsContainer = ({
  children,
  renderActions = (
    <Fragment>
      <Actions.SendToAIChatButton />
      <Actions.ExportPagesToPDFButton />
      <Divider sx={{ mx: 2 }} orientation="vertical" flexItem />
      <Actions.WorkspaceToggleButtons />
      <Actions.ColorsPickerButton />
      <Actions.TagPickerButton />
      <Actions.RotateDropdown />
    </Fragment>
  )
}:Props) => {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const newDesignEnabled = useAppSelector(selectNewDesignEnabled);
  const selectedPageIds = useAppSelector(selectSelectedPageIds);

  const handleClearSelectedPages = useCallback(() => {
    dispatch(PagesToolbarActions.clearSelectedPages());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      handleClearSelectedPages();
    }
  }, [handleClearSelectedPages]);

  const hasSelectedPages = selectedPageIds.length > 0;
  const selectedPagesCount = selectedPageIds.length;

  const renderSelectAll = () => (
    <Actions.SelectAllToggleButton />
  )

  if ( !hasSelectedPages ) return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, gap: 1 }}>
      <Box sx={{ flexGrow: 1 }}>{children || null}</Box>
      {newDesignEnabled ? renderSelectAll() : null}
    </Box>
  );
  return (
    <Box sx={{ display: 'flex', flexGrow: 1 }}>
      <Box sx={{
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        gap: 1,
        '@media (max-width: 1919px)': {
          gap: 2,
          position: 'fixed',
          left: '50%', bottom: 0,
          transform: 'translateX(-50%)',
          mb: 4,
          p: 2,
          borderRadius: 1,
          backgroundColor: 'white',
          boxShadow: 3,
          zIndex: 1200
        }
      }}>
        <IconButton
          name="Clear selected pages"
          onClick={handleClearSelectedPages}
        ><CloseIcon /></IconButton>
        <Typography sx={{ flexGrow: 1 }}>{selectedPagesCount} selected</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>{renderActions}</Box>
      </Box>
      <Box sx={{
        display: 'none',
        '@media (max-width: 1919px)': {
          display: 'flex',
          flexGrow: 1
        }
      }} />
      {renderSelectAll()}
    </Box>
  )
}

export default ActionsContainer;
